import style from "./hourlycast.module.css";
import { DayCard } from "../cards/daycard/DayCard";
import { Weather } from "../../types/variables/Variables";
import { Slider } from "../slider/Slider";
import { Title } from "../text/title/Title";
import { TabComponent } from "../tab/Tab";
import { HourlyChart } from "./chart/HourlyCastChart";
import { useLanguage } from "../../components/contexts/LanguageContext";
import translations from "../../components/translations";
import { format, addDays } from 'date-fns';
import { useGetData } from "../../hooks/getData/useGetData";
import { useEffect, useState } from "react";
import { useParams } from "../../hooks/common/useParams";
import DayCardSkeleton from "../cards/daycard/Skeleton";


function HourlyCast() {
  const { useUrlParamiters } = useParams()
  const { orgUnit } = useUrlParamiters()
  const { getData, loading } = useGetData()
  const { selectedLanguage } = useLanguage();
  const [forecast, setForeCast] = useState<any>([])

  useEffect(() => {
    getData(`climateData/future?periodType=DAILY_RANGE&startDate=${format(new Date(), 'yyyyMMdd')}&endDate=${format(addDays(new Date(), 9), 'yyyyMMdd')}&organisationUnitId=${orgUnit}`)
      .then((response) => {
        const foreCast: any[] = []
        response?.climateData?.forEach((element: any, index: number) => {
          foreCast.push({
            day: format(new Date(element?.period), 'dd MMM'),
            weather: element?.weatherIcon,
            high: element?.maxAirTemperature,
            low: element?.minAirTemperature,
          })
        });
        setForeCast(foreCast)
      })
  }, [orgUnit])

  return (
    <section>
      <Title label={translations[selectedLanguage].forecastNextDays} />

      <div className={style.hourlycast}>
        <Slider
          cards={
            loading ?
              Array.from({ length: 10 }).map(() => (<DayCardSkeleton />)) :
              forecast.map((day: any, index: number) => (<DayCard key={index} weather={day} />))
          }
        />      

        <TabComponent
          tabs={[
            {
              label: translations[selectedLanguage].summary,
              component: <HourlyChart
                weather={forecast[0]?.weather}
                data={[31, 30, 29, 27, 27, 26, 25, 25, 25, 28, 31, 32]}
                categories={["Agora", "17:00", "19:00", "21:00", "23:00", "01:00", "03:00", "05:00", "07:00", "09:00", "11:00", "13:00",]}
              />,
            },
          ]}
        />
      </div>
    </section>
  );
}

export { HourlyCast };
